export function setCookie(cname, cvalue, exhours=24, path="/", domain=window.location.hostname) {
    const d = new Date();
    d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    let cookie = cname + "=" + cvalue + ";" + "path=" + path + ";domain=" + domain + ";";
    if (exhours < 0)
        cookie += cname + "=" + cvalue + ";max-age=0";
    else
        cookie += expires;
    document.cookie = cookie;
}

export function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./src/utils/cookieUtils.js